import { Box, Flex, Text } from '@chakra-ui/react';
// import { useNavigate } from 'react-router-dom';

import Button from 'components/Button';
import CopyClipboard from 'components/CopyClipboard';
import { AnimatedMascot } from 'components/Mascot';
// import { useFetchADPAuthCode } from 'hooks/integrations/useFetchADPAuthCode';
import { useFetchAdpUniqueKey } from 'hooks/integrations/useFetchAdpUniqueKey';
// import { useReconnectADP } from 'hooks/integrations/useReconnectADP';
import { useSaveADPAuthCode } from 'hooks/integrations/useSaveADPAuthCode';
import { useIntegrationStore } from 'store/useIntegrationStore';

import ADPSettings from '../Settings';

const Configuration = () => {
  // const { data: adpOauthUrlData, status: adpOauthUrlStatus } = useFetchADPAuthCode();
  const { data: adpUniqueKey, status: adpUniqueKeyStatus } = useFetchAdpUniqueKey();
  const { status: adpAuthSaveStatus, mutate: adpAuthSaveMutate } = useSaveADPAuthCode();
  // const { status: adpReconnectStatus, mutate: adpReconnectMutate } = useReconnectADP();

  // const navigate = useNavigate();

  const integrationListData: any = useIntegrationStore(state => state.integrationList);
  const adpIntegrationData = integrationListData.filter((tab: any) => tab.key === 'adp')[0];
  const adpRedirectUrl: string = import.meta.env.VITE_ADP_URL;

  const getCode = (e: any) => {
    const tempFix = e.origin + '/';
    if (tempFix === import.meta.env.VITE_CURRENT_URL) {
      window.removeEventListener('message', getCode);
      adpAuthSaveMutate(e.data);
    }
  };

  // const onReconnect = () => {
  //   adpReconnectMutate();
  // };

  return (
    <>
      {!adpIntegrationData.is_connected ? (
        <Flex flexDirection="column" alignItems="flex-end">
          <Flex justifyContent="flex-end" mb="3">
            <CopyClipboard
              copyValue={adpUniqueKey?.payload.adp_sub_code}
              isLoading={adpUniqueKeyStatus === 'loading'}
              toolTipDesc="Copy this key to use the ADP Connector"
              label="Copy this key to use the ADP Connector:"
            />
          </Flex>
          <Box
            padding="20px 40px"
            border="1px solid"
            borderColor="gray.400"
            background="white"
            textAlign="center"
            w="full"
            mb={6}
          >
            <AnimatedMascot type="barking" />
            <Text>Click on Enable to start the integration process.</Text>
          </Box>
          <a href={adpRedirectUrl} target="_blank" rel="noreferrer">
            <Button ml="auto" isLoading={adpAuthSaveStatus === 'loading'}>
              Enable
            </Button>
          </a>
        </Flex>
      ) : (
        <>
          <ADPSettings adpUniqueKey={adpUniqueKey} />
          {/* <Flex flexDirection="column">
            <Box textAlign="right">
              <Button
                _hover={{ bg: 'rgba(255, 103, 32, 0.2)' }}
                background="rgba(255, 103, 32, 0.1)"
                colorScheme="rgba(255, 103, 32, 0.3)"
                color="secondary.500"
                mr={2}
                onClick={() => navigate(routePaths.integrations.adp.mapping)}
              >
                View Mapping
              </Button>
              <Button
                ml="auto"
                fontWeight="bold"
                background="rgba(39, 174, 96, 0.2)"
                color="success.500"
                _hover={{ bg: 'rgba(39, 174, 96, 0.4)' }}
                isLoading={adpReconnectStatus === 'loading'}
                onClick={onReconnect}
              >
                Reconnect
              </Button>
            </Box>
          </Flex> */}
        </>
      )}
    </>
  );
};
export default Configuration;
